import React, { useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MainCard from 'components/Cards/MainCard';
import SubCard from 'components/Cards/SubCard';
import ReportFileExports from 'components/Reports/FileExports';
import ApiHelper from 'utils/apiHelper';
import { gridSpacing, dateRangeOptions } from 'utils/constants';
import { handleUpdateReportDateRange, convertDate } from 'utils/commonHelpers';

/*
    report holds the name of the report and attribs (no attribs?)
    sections holds the report Section 'value' and attribs
    paragraphs holds the Paragraph 'bodytext' and attribs and
    data.  If type != 'default', holds type of chart, values, and data
*/
const initialState = {
    report: { values: [], attribs: [] },
    sections: { values: [], attribs: [] },
    paragraphs: { values: [], attribs: [] }
};

const ReportsBaseline = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const [startDate, setStartDate] = useState(today.setMonth(today.getMonth() - 1));
    const [endDate, setEndDate] = useState(new Date());
    const [dateRangeValue, setDateRangeValue] = useState('1month');
    const [timeInterval, setTimeInterval] = useState('day');
    const [baselineData, setBaselineData] = useState([initialState]);
    const options = '';

    const handleChangeDateRangeValue = (e) => {
        const value = e.target.value;
        setDateRangeValue(value);
        const updatedStartDate = handleUpdateReportDateRange(value);
        setStartDate(updatedStartDate);
    };

    const getBaselineData = () => {
        setLoading(true);
        ApiHelper.post('/api/reports/baseline/', {
            start_date: convertDate(startDate),
            end_date: convertDate(endDate),
            time_interval: timeInterval === 0 ? '' : timeInterval.toString()
        })
            .then((res) => {
                setBaselineData(res.data);
                setLoading(false);
            })
            .catch(() => {
                setBaselineData(initialState);
                setLoading(false);
                toast.warning('There is no Baseline Report data');
            });
    };

    /*const seriesOfReportdata = baselineData['type']['values'];
    baselineData['report']['values'];
    const optionsOfReportdata = {
        chart: {
            toolbar: {
                show: false
            }
        },
        title: {
            text: baselineData.report.name,
            style: {
                fontSize: '16px',
                fontWeight: '500'
            }
        },
        labels: baselineData.data.labels,
        legend: { position: 'bottom' }
    };*/

    return (
        <MainCard title="Energy Reports Management" cardHeaderTitle="Baseline Energy Report" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>Provides a complete Baseline Audit Comparison report.</Typography>
                </Grid>
                <Grid item xs={3}>
                    <SubCard title="Filters">
                        <Grid container>
                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Start Date"
                                        value={startDate}
                                        onChange={(newValue) => {
                                            setStartDate(newValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="End Date"
                                        value={endDate}
                                        onChange={(newValue) => {
                                            setEndDate(newValue);
                                        }}
                                        renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Date Range</InputLabel>
                                    <Select
                                        label="Date Range"
                                        value={dateRangeValue}
                                        name="date_range"
                                        onChange={handleChangeDateRangeValue}
                                    >
                                        {dateRangeOptions.map((data, key) => (
                                            <MenuItem value={data.value} key={key}>
                                                {data.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sx={{ mt: 4 }}>
                                <LoadingButton
                                    color="primary"
                                    variant="contained"
                                    sx={{ width: '100%' }}
                                    loading={loading}
                                    onClick={getBaselineData}
                                >
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
                <Grid item xs={9}>
                    {loading === true ? (
                        <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>Please wait...</Typography>
                    ) : baselineData.length === 0 ? (
                        <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                            No data for the Baseline report
                        </Typography>
                    ) : (
                        <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                            There IS data for the Baseline report
                        </Typography>
                        //<Chart options={optionsOfDevicesOS} series={seriesOfDevicesOS} type="pie" height={500} />
                        //<Chart id="baselineReport" options={options} type="bar" series={[]} width="80%" />
                    )}
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ReportsBaseline;
